import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Button, IconSVG } from './index';

export interface ErrorDisplayProps {
  error: string | null;
  onRetry?: () => void;
  className?: string;
}

/**
 * ErrorDisplay component for showing error messages with a retry button
 */
const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  onRetry,
  className = '',
}) => {
  const { t } = useTranslation();
  if (!error) return null;

  return (
    <div 
      className={classNames(
        'flex flex-col items-center justify-center text-center p-6 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-100 dark:border-red-900/30',
        className
      )}
      role="alert"
    >
      <IconSVG 
        icon="exclamation-circle" 
        className="w-12 h-12 text-red-500 dark:text-red-400 mb-3" 
      />
      <h2 className="text-lg font-semibold text-red-800 dark:text-red-300 mb-2">
        {t('common.errors.generic')}
      </h2>
      <p className="text-red-700 dark:text-red-300 mb-4">
        {error}
      </p>
      {onRetry && (
        <Button
          variant="outlined"
          color="danger"
          onClick={onRetry}
          className="mt-2"
        >
          {t('common.actions.retry')}
        </Button>
      )}
    </div>
  );
};

export default ErrorDisplay;